import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type {
	CategoryEntryPointExtraProps,
	CategoryEntryPointParams,
	CategoryEntryPointRuntimeProps,
} from '../../types';
import { resolveTemplateProduct } from '../recommended/resolveTemplateProduct';
import TemplateResultsQuery from './__generated__/TemplateResultsQuery.graphql';
import type { TemplateResultsQuery as TemplateResultsQueryType } from './__generated__/TemplateResultsQuery.graphql';

type TemplateResultsEntryPointComponent = EntryPointComponent<
	{ templateResultsQuery: TemplateResultsQueryType },
	Record<string, never>,
	CategoryEntryPointRuntimeProps,
	CategoryEntryPointExtraProps
>;

export const templateResultsEntryPoint: EntryPoint<
	TemplateResultsEntryPointComponent,
	CategoryEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<TemplateResultsEntryPointComponent>(() => import(/* webpackChunkName: "@atlaskit-internal_studio-browse-kit_template-results" */ "./TemplateResults"), { moduleId: "2e339812", moduleName: "TemplateResults", modulePath: "../platform/packages/ai-mate/studio-agent-browse/src/entrypoints/templates/TemplateResults.tsx", priority: "interaction", moduleId: 'studio-browse-kit_template-results' }),
	getPreloadProps: ({ cloudId, product, fetchPolicy = 'store-or-network' }) => ({
		queries: {
			templateResultsQuery: {
				parameters: TemplateResultsQuery,
				variables: { cloudId, product: resolveTemplateProduct(product), first: 50 },
				options: { fetchPolicy },
			},
		},
		extraProps: { product },
	}),
});
